import { atom } from "recoil";

export const calendarState = atom({
    key: 'calendarHorizontal',
    default: {
        minDate: new Date(),
        value: null,
        monthSelected: new Date().getMonth() + 1
    }
})

export const dayDefaultAvailableState = atom({
    key: 'dayDefaultAvailable',
    default: null
});

export const showCalendarHorizontalState = atom({
    key: 'showCalendarHorizontal',
    default: false
})